module.exports = __webpack_public_path__ + "static/media/czskiLogo.8e70ef75.png";